<template>
	<div class="prebuild-review">
		<hr>
		<div class="prebuild-review__heading">
			<p class="prebuild-review__info">
				<span class="prebuild-review__username">{{ review.username }}</span><span class="hidden-xs">,</span>

				{{ review.state }}<span class="hidden-xs">.</span>
				<i>
					<span class="hidden-xs">Reviewed on</span> {{ review.date | shortHumanizeDate }}
				</i>
			</p>
			<div class="prebuild-review__rating">
				<star-rating
					:rating="+review.rating"
					active-color="#640a92"
					inactive-color="#5f686d"
					:star-size="17"
					:show-rating="false"
					:increment="0.5"
					:border-width="2"
					:rounded-corners="true"
					:read-only="true"
					:star-points="[23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17]"
				/>
			</div>
		</div>
		<p class="prebuild-review__text">
			<template v-if="shouldShowFullReview">
				{{ review.description }}
			</template>
			<template v-else>
				{{ review.description | truncate(200, '...', false) }}
			</template>
		</p>
		<a
			v-if="review.description.length >= 200"
			href="#"
			@click.prevent="shouldShowFullReview = !shouldShowFullReview"
			class="prebuild-review__show-more"
		>
			<template v-if="shouldShowFullReview">
				&leftarrow; Show Less
			</template>
			<template v-else>
				Show More &rightarrow;
			</template>
		</a>
	</div>
</template>

<script>
export default {
	name: "PrebuildReview",
	props: {
		review: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			shouldShowFullReview: false
		};
	}
};
</script>

<style lang="scss">
@media (max-width: 580px) {
    .prebuild-review {
        &-rating {
            .vue-star-rating-star {
                margin: 0 !important;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.prebuild-review {
    margin-bottom: 45px;

    hr {
        border-top: 1px solid #dadde0;
        margin-bottom: 15px;
    }

    &__heading {
        display: flex;
        margin-bottom: 15px;
    }

    &__info {
        margin-right: auto;
        color: #5F707F;
        font-size: 16px;

        @media (max-width: 580px) {
            display: flex;
            flex-direction: column;
        }
    }

    &__username {
        font-weight: 700;
        color: $black;
    }

    &__rating {
        pointer-events: none;
    }

    &__text {
        color: #5F707F;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 5px;
    }

    &__show-more {
        color: #792B99;
        font-size: 16px;

        &:hover {
            color: darken(#792B99, 10%);
            text-decoration: underline;
        }
    }
}
</style>
